<template>
  <div>
    <div class="mb-3">
      <hr />
      <h5>{{ $t("wizard.form.title.basic-information") }}</h5>
      <p>{{ $t("wizard.form.title.fill-all") }}</p>
    </div>
    <div class="row p-3" ref="wizard1">
      <div class="col-sm-6">
        <div class="pr-3">
          <div class="form-group row mb-3">
            <label class="col-form-label" for="title">{{
              $t("wizard.form.label.profile-target")
            }}</label>
            <input
              id="title"
              type="text"
              class="form-control"
              name="title"
              v-model="form.wizard1.title"
              :placeholder="$t('wizard.form.label.profile-target')"
              :class="{
                'is-invalid':
                  submitted && $v.form.wizard1.title.$error,
              }"
              v-on:keyup="onInputTitle()"
            />
            <div
              v-if="submitted && $v.form.wizard1.title.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.wizard1.title.required">{{
                $t("form.error.text")
              }}</span>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-form-label">{{
              $t("wizard.form.label.description")
            }}</label>
            <input
              id="description"
              type="description"
              name="description"
              class="form-control"
              v-model="form.wizard1.description"
              :placeholder="$t('wizard.form.label.description')"
              :class="{
                'is-invalid':
                  submitted && $v.form.wizard1.description.$error,
              }"
            />
            <div
              v-if="submitted && $v.form.wizard1.description.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.wizard1.description.required">{{
                $t("form.error.text")
              }}</span>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-form-label"
              >{{ $t("wizard.form.label.profile-images") }}
              <span><small>(Max. 2Mb)</small></span></label
            >
            <div class="custom-file">
              <b-form-file
                :state="fileValid"
                :placeholder="
                  $t('wizard.form.label.image_placeholder')
                "
                :drop-placeholder="
                  $t('wizard.form.label.image_placeholder_drop')
                "
                :class="fileValid ? '' : 'is-invalid'"
                @change="upImage"
              ></b-form-file>
              <div v-if="!fileValid" class="invalid-feedback">
                <span>{{
                  $t("wizard.form.validation.max_size")
                }}</span>
              </div>
            </div>

            <div
              class="similar-target d-flex mt-4 align-items-center"
              v-if="similar.length != 0"
            >
              <h5>Similar Target :</h5>
              <div class="list-target ml-3">
                <div
                  class="badge badge-soft-primary mr-2"
                  v-for="sim in similar"
                  :key="sim.id_target"
                >
                  <a
                    href="javascript: void(0);"
                    class="team-member d-inline-block"
                  >
                    <img
                      src="@/assets/images/users/avatar-1.jpg"
                      class="rounded-circle avatar-xs m-1"
                      alt
                    />
                  </a>
                  {{ sim.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 text-right">
        <div class="pl-3">
          <div class="form-group row mb-3">
            <label class="col-form-label" for="category">{{
              $t("wizard.form.label.profile-category")
            }}</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="form.wizard1.category"
              :class="{
                'is-invalid':
                  submitted && $v.form.wizard1.category.$error,
              }"
            >
              <option
                v-for="cat in category"
                :key="cat.id_category"
                :value="cat.id_category"
              >
                {{ cat.category_name }}
              </option>
            </select>
            <div
              v-if="submitted && $v.form.wizard1.category.$error"
              class="invalid-feedback text-left"
            >
              <span v-if="!$v.form.wizard1.category.required">{{
                $t("form.error.text")
              }}</span>
            </div>
          </div>

          <div class="form-group row mb-3">
            <label class="col-form-label" for="users">{{
              $t("wizard.form.label.manager")
            }}</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="form.wizard1.manager"
              :class="{
                'is-invalid':
                  submitted && $v.form.wizard1.manager.$error,
              }"
            >
              <option
                v-for="usr in users"
                :key="usr.id_users"
                :value="usr.id_user"
              >
                {{ usr.username }}
              </option>
            </select>
            <div
              v-if="submitted && $v.form.wizard1.manager.$error"
              class="text-left invalid-feedback"
            >
              <span v-if="!$v.form.wizard1.manager.required">{{
                $t("form.error.text")
              }}</span>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-form-label"
              >{{ $t("wizard.form.label.relation_profile") }}
              <span><small>(Max. 6 profile)</small></span></label
            >
            <b-form-tags
              class="text-left"
              id="tags-with-dropdown"
              v-model="form.wizard1.relation"
              no-outer-focus
            >
              <template
                v-slot="{ tags, disabled, addTag, removeTag }"
              >
                <ul
                  v-if="tags.length > 0"
                  class="list-inline d-inline-block mb-2"
                >
                  <li
                    v-for="(tag, index) in tags"
                    :key="index"
                    class="list-inline-item mb-2"
                  >
                    <b-form-tag
                      @remove="removeTag(tag)"
                      :title="tag"
                      :disabled="disabled"
                      variant="primary"
                    >
                      <div class="team">
                        <a
                          href="javascript: void(0);"
                          class="team-member d-inline-block"
                        >
                          <img
                            :src="url_image + JSON.parse(tag).image"
                            class="rounded-circle avatar-xs m-1"
                            alt
                          />
                        </a>
                      </div>
                      {{ JSON.parse(tag).name }}
                    </b-form-tag>
                  </li>
                </ul>

                <b-dropdown
                  size="sm"
                  variant="outline-secondary"
                  block
                  menu-class="w-100"
                  :disabled="
                    form.wizard1.relation.length < 6 ? false : true
                  "
                >
                  <template #button-content>
                    {{ $t("wizard.form.button.relation_profile") }}
                  </template>
                  <b-dropdown-form @submit.stop.prevent="() => {}">
                    <b-form-group
                      :label="
                        $t(
                          'wizard.form.label.relation_profile_search'
                        )
                      "
                      label-for="tag-search-input"
                      label-cols-md="auto"
                      class="mb-0"
                      label-size="sm"
                      :description="searchDesc"
                      :disabled="disabled"
                    >
                      <b-form-input
                        v-on:keyup="
                          search != ''
                            ? (show = true)
                            : (show = false)
                        "
                        v-model="search"
                        id="tag-search-input"
                        type="search"
                        size="sm"
                        autocomplete="off"
                      ></b-form-input>
                    </b-form-group>
                  </b-dropdown-form>
                  <b-dropdown-divider></b-dropdown-divider>

                  <b-dropdown-item-button
                    v-show="show"
                    v-for="(option, index) in availableOptions"
                    :key="index"
                    @click="onOptionClick({ option, addTag })"
                  >
                    {{ option.name }}
                  </b-dropdown-item-button>
                  <b-dropdown-text
                    v-if="availableOptions.length === 0"
                  >
                    {{ $t("wizard.form.validation.not_match2") }}
                  </b-dropdown-text>
                </b-dropdown>
              </template>
            </b-form-tags>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import Vue from "vue";
import appConfig from "@/app.config";
import VueSlideBar from "vue-slide-bar";
import CitizenService from "@/helpers/citizen.service";
import { required } from "vuelidate/lib/validators";
import CategoryService from "@/helpers/category.service";
import UserService from "@/helpers/user.service";
import SherlockService from "@/helpers/sherlock.service";
import moment from "moment";
import TargetService from "@/helpers/target-profile.service";
import SocmedService from "@/helpers/socmed.service";
import TwintService from "@/helpers/twint.service";
import { gmapApi } from "vue2-google-maps";
import PhoneService from "@/helpers/phone.service";
import WebsiteService from "@/helpers/website.service.js";
import PreferenceService from "@/helpers/preference.service.js";
import Swal from "sweetalert2";

/**
 * Form wizard component
 */
export default {
  props: {
    "doValidation": Boolean,
    "idTarget": { type: String, default: "" },
  },
  components: {
    FormWizard,
    TabContent,
  },
  watch: {
    doValidation: {
      immediate: true,
      handler(n) {
        if (n) {
          this.validationWizard();
        }
      },
    },
  },
  data() {
    return {
      backUrl: "/project/template",
      url_image:
        process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
      form: {
        wizard1: {
          title: "",
          description: "",
          other_description: "",
          relation: [],
          image_project: null,
          manager: "",
          category: "",
          status: 1,
        },
      },
      submitted: false,
      fileValid: true,
      similar: [],
      category: [],
      users: [],
      search: "",
      options: [],
      wizard_validation: {
        invalid: false,
      },
    };
  },

  computed: {
    rows() {
      return this.tableData.length;
    },
    criteria() {
      return this.search.trim().toLowerCase();
    },
    availableOptions() {
      const criteria = this.criteria;
      let element = [];
      try {
        for (let i = 0; i < this.form.wizard1.relation.length; i++) {
          element.push(JSON.parse(this.form.wizard1.relation[i]).id);
        }
      } catch (e) {
        element = [];
      }
      const options = this.options.filter(
        (opt) => element.indexOf(opt.id) === -1
      );
      this.show = false;
      if (criteria) {
        this.show = true;
        return options.filter((opt) =>
          opt.name.toLowerCase().includes(criteria)
        );
      }
      return options;
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return this.$t("wizard.form.validation.not_match1");
      }
      return "";
    },
    validFormat() {
      if (this.validformat != null) {
        if (this.validformat) {
          return "is-valid";
        } else {
          return "is-invalid";
        }
      }
    },
  },

  validations: {
    form: {
      wizard1: {
        title: { required },
        description: { required },
        other_description: {},
        manager: { required },
        relation: {},
        image_project: {},
        category: { required },
      },
    },
  },

  methods: {
    onInputTitle() {
      if (this.form.wizard1.title != "") {
        const dataBody = {
          title: this.form.wizard1.title,
        };
        TargetService.checkSimilar(dataBody)
          .then((response) => {
            this.similar = response.data.data;
          })
          .catch((err) => {
            this.similar = [];
            console.log(err);
          });
      }else{
        this.similiar = [];
      }
    },

    //================================== wizard 1 ===================================//
    /* =======================================
         get all target for input relation profile
         =======================================
      */
    listProfile() {
      TargetService.getAllTarget()
        .then((response) => {
          response.data.data.forEach((val) => {
            const opt = {
              name: val.title,
              id: val.id_target,
              image: val.image_project,
            };
            this.options.push(opt);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onOptionClick({ option, addTag }) {
      this.form.wizard1.relation.push({
        name: option.name,
        id: option.id,
        image: option.image,
      });
      this.show = false;
      this.search = "";
    },
    /** ======================================*/

    /* =======================================
         upload image and filter max size
         =======================================
      */
    upImage(evt) {
      const fileSize = evt.target.files[0].size / 1024 / 1024;
      if (fileSize > 2) {
        this.fileValid = false;
      } else {
        this.fileValid = true;
        this.form.wizard1.image_project = evt.target.files[0];
      }
    },
    /** ======================================*/

    /* =======================================
         get all category and user where type manager
         =======================================
      */
    getCategory() {
      CategoryService.list()
        .then((response) => {
          this.category = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getUser() {
      UserService.getAllManager()
        .then((response) => {
          this.users = [];
          response.data.data.forEach((val) => {
            const data = {
              id_user: val.id_user,
              username: val.username,
              user_type: val.user_type,
            };
            this.users.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /** ======================================*/

    /* =======================================
         save basic information of target
         =======================================
      */
    async saveBasicTarget() {
      this.submitted = true;
      this.$v.form.wizard1.$touch();
      this.wizard_validation.invalid = this.$v.form.wizard1.$invalid;
      if (this.idTarget == "") {
        // this.loadingProcess = true;
        // this.statusProcess = "process";
        // this.messageProcess = "Saving basic information target ..";
        const formCreate = new FormData();
        formCreate.append("title", this.form.wizard1.title);
        formCreate.append("description", this.form.wizard1.description);
        formCreate.append(
          "other_description",
          this.form.wizard1.other_description
        );
        formCreate.append("manager", this.form.wizard1.manager);
        formCreate.append("id_category", this.form.wizard1.category);
        formCreate.append("category_score", 0);
        formCreate.append("status_id", this.form.wizard1.status);
        formCreate.append("relation_profile", this.form.wizard1.relation);
        if (this.form.wizard1.image_project != null) {
          formCreate.append(
            "image_project",
            this.form.wizard1.image_project,
            this.form.wizard1.image_project.name
          );
        }
        await TargetService.create(formCreate)
          .then((response) => {
            this.$emit("id-target", response.data.data.id_target);
            this.$emit("id-category", response.data.data.id_category);
            this.$emit("target-title", response.data.data.title);
            this.$emit("next-tab");
            // this.wizard_validation.status = "sent";
            // this.wizard_validation.id_record = response.data.data.id_target;
            // this.statusProcess = true;
            // this.messageProcess = "Success saving target";
            // setTimeout(() => {
            //   this.loadingProcess = false;
            // }, 500);
          })
          .catch((err) => {
            // this.statusProcess = false;
            // this.messageProcess = "Failed saving target";
            // setTimeout(() => {
            //   this.loadingProcess = false;
            // }, 500);
            // console.log(err);
          });
      } else if (this.idTarget != "") {
        // this.loadingProcess = true;
        // this.statusProcess = "process";
        // this.messageProcess = "Updating basic information target ..";
        const formUpdate = new FormData();
        formUpdate.append("title", this.form.wizard1.title);
        formUpdate.append("description", this.form.wizard1.description);
        formUpdate.append(
          "other_description",
          this.form.wizard1.other_description
        );
        formUpdate.append("manager", this.form.wizard1.manager);
        formUpdate.append("id_category", this.form.wizard1.category);
        formUpdate.append("category_score", 0);
        formUpdate.append("status_id", this.form.wizard1.status);
        formUpdate.append("relation_profile", this.form.wizard1.relation);
        if (this.form.wizard1.image_project != null) {
          formUpdate.append(
            "image_project",
            this.form.wizard1.image_project,
            this.form.wizard1.image_project.name
          );
        }
        await TargetService.update(this.wizard_validation.id_record, formUpdate)
          .then((response) => {
            this.$emit("id-target", response.data.data.id_target);
            this.$emit("next-tab");
            // this.wizard_validation.status = "sent";
            // this.statusProcess = true;
            // this.messageProcess = "Success updating target";
            // setTimeout(() => {
            //   this.loadingProcess = false;
            // }, 500);
          })
          .catch((err) => {
            // this.statusProcess = false;
            // this.messageProcess = "Failed updating target";
            // setTimeout(() => {
            //   this.loadingProcess = false;
            // }, 500);
            // console.log(err);
          });
      }
      // return this.wizard_validation.invalid;
    },

    /** ======================================*/
    /* =======================================
         validation next button wizard 1
         =======================================
      */
    validationWizard() {
      this.submitted = true;
      this.$v.form.wizard1.$touch();
      this.wizard_validation.invalid = this.$v.form.wizard1.$invalid;
      if (this.wizard_validation.invalid) {
         this.$emit("validation-failed");
      }else{
        this.saveBasicTarget();
      }
      // let flag = false;
      // let result = await this.saveBasicTarget();
      // this.refreshSlider();
      // await new Promise((resolve, reject) => {
      //   if (result) {
      //     flag = false;
      //     reject("invalid");
      //   } else {
      //     setTimeout(function () {
      //       flag = true;
      //       resolve("valid");
      //     }, 1500);
      //   }
      // }).then();
      // return flag;
    },
    /** ======================================*/
    //================================== wizard 1 ===================================//

    //================================== support ===================================//
    getPreferences() {
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[0].ip_address;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    parseUrl(url) {
      let loc = new URL(url);
      let url_icon = "";
      switch (loc.host) {
        case "www.capfriendly.com":
          url_icon =
            loc.protocol +
            "//" +
            loc.host +
            "/assets/images/favicons/favicon.ico";
          break;

        default:
          url_icon = loc.protocol + "//" + loc.host + "/favicon.ico";
          break;
      }
      return url_icon;
    },
    generateCharAvatar(name) {
      name.split(/(?=[A-Z])/);
      if (name.length > 1) {
        return name[0].charAt(0) + name[1].charAt(0);
      } else {
        return name[0].charAt(0);
      }
    },
    next() {
      this.$refs.formwizard.nextTab();
    },
    updateTarget(data) {
      TargetService.update(this.wizard_validation.id_record, data)
        .then((response) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    resetTable() {
      this.tableData = [];
    },
    typeForm(e) {
      this.typesubmit = true;
      this.$v.$touch();
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    refreshSlider() {
      this.$watch(
        () => this.$refs.formwizard.activeTabIndex,
        () => {
          if (this.$refs.formwizard.activeTabIndex == 1) {
            this.$refs.slidebar.refresh();
          }
        }
      );
    },
    randomColor(idx) {
      let color = "";
      switch (idx) {
        case 1:
          color = "primary";
          break;
        case 2:
          color = "dark";
          break;
        case 3:
          color = "danger";
          break;
        case 4:
          color = "warning";
          break;
        case 5:
          color = "success";
          break;
        default:
          color = "secondary";
          break;
      }
      return color;
    },
    normalizeUrl() {
      if (this.form.website != "") {
        try {
          let url = new URL(this.form.website);
          return url.host.replace("www.", "");
        } catch (error) {
          return this.form.website;
        }
      } else {
        return "";
      }
    },
    //================================== support ===================================//
  },
  beforeMount() {
    // this.getPreferences();
    this.listProfile();
  },
  mounted() {
    this.availableOptions;
    this.getCategory();
    this.getUser();
  },
};
</script>

<style scoped>
/* .par {
  position: relative;
}

.cursor-pointer:hover {
  cursor: pointer;
}
.header-accordion-result:hover {
  cursor: pointer;
}
#tab-username {
  padding: 0;
} */
</style>
